<template>
  <form
    v-if="activeFacetValues?.length > 0"
    class="active-facets-wrapper"
  >
    <div class="active-facets">
      <button
        v-if="activeFacetValues?.length > 1"
        :disabled="isLoading"
        class="active-facets__facet hidden-mobile"
        type="button"
        :aria-label="$string('collection.filters.active_filters.remove_all_accessibility_text')"
        @click.prevent="$emit('facets-cleared')"
        v-text="$string('collection.filters.active_filters.remove_all_label')"
      />

      <button
        v-for="(facetValue, i) of activeFacetValues"
        :key="`${facetValue.value}-${i}`"
        :disabled="isLoading"
        class="active-facets__facet"
        type="button"
        :aria-label="$string(
          'collection.filters.active_filters.remove_value_accessibility_text',
          {
            replace: {
              value: facetValue.label,
            }
          })"
        @click.prevent="$emit('facet-value-changed', {
          field: facetValue.field,
          value: facetValue.value,
          selected: false,
        })"
      >
        <span
          v-if="facetValue.type === 'palette' && facetValue.field == 'ss_color_group'"
          :style="{
            backgroundImage: `url(https://cdn.shopify.com/s/files/1/0089/4432/0612/files/${
              facetValue.value.split(' ').join('-').toLowerCase()
            }.jpg)`
          }"
          class="active-facets__facet__color"
        />

        <span v-text="facetValue.label" />

        <span class="active-facets__facet__close" />
      </button>

      <button
        v-if="activeFacetValues?.length > 1"
        :disabled="isLoading"
        class="active-facets__facet hidden-desktop"
        type="button"
        :aria-label="$string('collection.filters.active_filters.remove_all_accessibility_text')"
        @click.prevent="$emit('facets-cleared')"
        v-text="$string('collection.filters.active_filters.remove_all_label')"
      />
    </div>
  </form>
</template>

<script>

/**
 * Vue: Active facets (active-facets)
 * -----------------------------------------------------------------------------
 * A bar displaying removable active SearchSpring facets.
 * @param {Array} activeFacetValues - The facets data.
 * @param {Object} isLoading - Whether the SS data is loading.
 *
 */

export default {
  name: 'ActiveFacets',

  props: {
    activeFacetValues: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  emits: {
    'facets-cleared': () => true,
    'facet-value-changed': (payload) => typeof payload === 'object',
  },
}
</script>

<style lang="scss">
@import './active-facets';
</style>
